module.exports = __webpack_public_path__ + "static/media/paper_lose.e4568288.png";